import { useMemo } from 'react';
import * as React from 'react';

import { EntryRacer } from '@/lib/apollo/types/gen/graphql';
import { defaultTheme } from '@/utility/theme';

import { BorderData } from '../style';

interface BracketNumberProps {
  bracketNum: number;
  entryRacers: EntryRacer[];
  index: number;
  isRecentResult?: boolean;
  isVelodromeResult?: boolean;
}

const BracketNumberData: React.FC<BracketNumberProps> = ({
  bracketNum,
  entryRacers,
  index,
  isRecentResult,
  isVelodromeResult,
}) => {
  /**
   * 配列内にある特定要素が何個存在するかを返す
   */
  const countElemInArray = (arr: Array<Number>, num: Number): number => {
    const counter = useMemo(() => {
      let count = 0;
      // eslint-disable-next-line consistent-return
      arr.forEach(n => {
        if (n === num) count += 1;
      });
      return count;
    }, [arr, num]);

    return counter;
  };

  return (
    <>
      {/* 一つ前の選手と枠番が同じ場合はtdを作らない */}
      {(index === 0 || bracketNum !== entryRacers![index - 1].bracketNum) && (
        <BorderData
          isBorderLeftNone={isRecentResult || isVelodromeResult}
          rowSpan={countElemInArray(
            entryRacers!.map(r => r.bracketNum),
            bracketNum,
          )}
          style={{
            backgroundColor: 'inherit',
            fontFamily: defaultTheme.font.family.bicycleNumber,
          }}
        >
          {bracketNum}
        </BorderData>
      )}
    </>
  );
};

export default BracketNumberData;
